"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledModalCard = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledModalCard = styled_components_1.default.div `
  padding-bottom: ${({ padding }) => (padding ? '30px' : '0')}
  width: 100%;
`;
